import React from "react";
import FormGroup from "../../../common/form/FormGroup";
import FormControls from "../../../common/form/FormControls";
import ErrorField from "../../../common/form/ErrorField";

export default function ResendForm({ responseError, disableSubmit, handleSubmit }) {
  return (
    <FormGroup>
      <div className="text-lg">Вы уверены, что хотите повторить отправку сообщений?</div>
      <ErrorField>{responseError}</ErrorField>
      <FormControls submitName="Отправить" onSubmit={handleSubmit} disableSubmit={disableSubmit} />
    </FormGroup>
  );
}
